
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7kAeIE", function(module, exports) {
/* RemixPanelButton.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $1sCHt = parcelRequire("1sCHt");


var $1pCE4 = parcelRequire("1pCE4");


var $dTEBe = parcelRequire("dTEBe");


var $hdBxM = parcelRequire("hdBxM");


var $k1Pvg = parcelRequire("k1Pvg");


var $lpNn5 = parcelRequire("lpNn5");


var $irnO2 = parcelRequire("irnO2");


var $kDDrf = parcelRequire("kDDrf");


var $bjY3F = parcelRequire("bjY3F");


var $8uM2K = parcelRequire("8uM2K");


var $aHcFH = parcelRequire("aHcFH");


var $1AJi3 = parcelRequire("1AJi3");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");


var $eCmUm = parcelRequire("eCmUm");


var $3WsfO = parcelRequire("3WsfO");


var $1Tfg5 = parcelRequire("1Tfg5");


var $hxqA6 = parcelRequire("hxqA6");


var $25qMx = parcelRequire("25qMx");


var $jln20 = parcelRequire("jln20");


var $d9tcB = parcelRequire("d9tcB");


var $bQm3c = parcelRequire("bQm3c");


var $jyA9t = parcelRequire("jyA9t");


var $c9vDa = parcelRequire("c9vDa");


var $gRU1O = parcelRequire("gRU1O");

const $3dbfc2b2d31d5d9f$export$3dba41599effe979 = 'objectSidebar';
const $3dbfc2b2d31d5d9f$export$799fbc783b1be702 = 'remixModalFromObjectLevelSidebar';

const $3dbfc2b2d31d5d9f$var$remixObjectPagePopupLoader = ()=>(parcelRequire("9T8LG"));
const $3dbfc2b2d31d5d9f$var$RemixObjectPagePopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "gUhap",
    name: "RemixObjectPagePopup",
    loader: async ()=>(await $3dbfc2b2d31d5d9f$var$remixObjectPagePopupLoader()).RemixObjectPagePopup
});
const $3dbfc2b2d31d5d9f$var$remixButtonContainerStyle = null;
const $3dbfc2b2d31d5d9f$var$popupTriggerOverlayStyle = null;
const $3dbfc2b2d31d5d9f$var$placeholderButtonStyle = null;
const $3dbfc2b2d31d5d9f$var$i18n = (0, $kSwu1.defineMessages)({
    remixPageLabel: {
        id: "object-sidebar-components.remix-page.label",
        defaultMessage: "Remix page"
    },
    remixPageTooltip: {
        id: "object-sidebar-components.remix-page.tooltip",
        defaultMessage: "Remix"
    },
    remixPageEmptyTooltip: {
        id: "object-sidebar-components.remix-page.empty-tooltip",
        defaultMessage: "Add content to this page to remix"
    },
    remixInProgressTooltip: {
        id: "object-sidebar-components.remix-page.in-progress-tooltip",
        defaultMessage: "Remix in progress"
    }
});
const $3dbfc2b2d31d5d9f$export$def261f8e2f8a585 = ({ contentId: contentId, contentBodyValue: contentBodyValue, getAdfDocument: getAdfDocument, isEditorEmpty: isEditorEmpty, isDisabled: isDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const reportLifecycleDiagnostic = (0, $3WsfO.useObjectSidebarRemixLifecycleDiagnostics)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { isLoggedIn: isLoggedIn, isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)(); // Match App.jsx: the Rovo submit path only exists when Rovo chat is allowed for this user.
    // The lifecycle session applies the same guard before hosting the coordinator, so that this
    // button and the coordinator agree on which path a click starts.
    const isRovoEnabled = isRovoLLMEnabled && isLoggedIn && accessStatus !== (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
    const shouldUseRovoRemixPath = isRovoEnabled && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'variant2');
    const { didPrefetch: didPrefetchSpaceOptions, hiddenOptions: prefetchedSpaceHiddenOptions } = (0, $hxqA6.useSpaceRemixOptionsPrefetch)({
        // The modal records the permissions exposure when opened; prefetching must not record it.
        // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
        enabled: (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc_maui_remix_attachment_permissions', 'isEnabled', true)
    });
    const { showSmartCreationModal: showSmartCreationModal } = (0, $jyA9t.useSmartCreationModalState)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { width: rightSidebarWidth } = rightSidebarContext.getCurrent() || {};
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const publishOpenRovoRemix = (0, $hdBxM.usePublish)((0, $k1Pvg.Topics).AI_MATE);
    const publishRovoRemixLaunch = (0, $hdBxM.usePublish)((0, $k1Pvg.Topics).ROVO_REMIX_LAUNCH);
    const { openConversationAssistant: openConversationAssistant, isConversationAssistantSidebarActive: isConversationAssistantSidebarActive, mode: mode } = (0, $1AJi3.useToggleConversationAssistant)();
    const { admitObjectSidebarRemixLifecycle: admitObjectSidebarRemixLifecycle, clearRovoRemixStarted: clearRovoRemixStarted, closeObjectSidebarRemixModal: closeObjectSidebarRemixModal, hasAdapter: shouldAttemptLifecycleAdmission, isObjectSidebarRemixModalOpen: isObjectSidebarRemixModalOpen, isRemixStartBlockedByActiveFlow: isRemixStartBlockedByActiveFlow, isRovoRemixStarted: isRovoRemixStarted, markRovoRemixStarted: markRovoRemixStarted, openObjectSidebarRemixModal: openObjectSidebarRemixModal, registerPopupAnchor: registerPopupAnchor, releaseRetainedLifecycleForToken: releaseRetainedLifecycleForToken, retainedLifecycleToken: retainedLifecycleToken } = (0, $c9vDa.useObjectSidebarRemixLifecycleSession)(); // `handleOpenSidebarConversation` is invoked asynchronously from the remix flow
    // (after `sendAIFCPrompt` resolves), by which point the sidebar's active state may
    // have changed. Track the latest value in a ref so the guard reads the current
    // value at invocation time rather than a stale value captured at render time.
    // Mirrors the existing async-safe ref pattern (e.g. `isRemixCancelled`).
    const isConversationAssistantSidebarActiveRef = (0, $cozmU.useRef)(isConversationAssistantSidebarActive);
    isConversationAssistantSidebarActiveRef.current = isConversationAssistantSidebarActive;
    const handleOpenSidebarConversation = (0, $cozmU.useCallback)((conversationId)=>{
        (0, $dTEBe.updatePageRovoParams)({
            pathway: 'chat',
            conversationId: conversationId
        });
        if (!isConversationAssistantSidebarActiveRef.current) openConversationAssistant('sidebar');
    }, [
        openConversationAssistant
    ]);
    const isRemixStartActive = (0, $cozmU.useRef)(false); // Set when this button asked the Rovo panel to open. Kept local rather than reading the shared
    // `isRovoRemixStarted`, because the session provider clears that flag on the same panel close
    // this effect reacts to, and whichever effect ran first would otherwise decide whether the
    // experience gets aborted.
    const hasStartedRovoRemixRef = (0, $cozmU.useRef)(false);
    const hasOpenedRemixModalRef = (0, $cozmU.useRef)(false);
    const startRequestIdRef = (0, $cozmU.useRef)(0);
    const adfSourceVersionRef = (0, $cozmU.useRef)(0);
    const lifecycleAdfSourceRef = (0, $cozmU.useRef)({
        contentBodyValue: contentBodyValue,
        getAdfDocument: getAdfDocument
    });
    const isLifecycleTreatmentActiveRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!isLifecycleTreatmentActiveRef.current) return;
        lifecycleAdfSourceRef.current = {
            contentBodyValue: contentBodyValue,
            getAdfDocument: getAdfDocument
        };
        adfSourceVersionRef.current += 1;
    }, [
        contentBodyValue,
        getAdfDocument
    ]);
    (0, $cozmU.useEffect)(()=>()=>{
            if (!isLifecycleTreatmentActiveRef.current) return;
            adfSourceVersionRef.current += 1;
            startRequestIdRef.current += 1;
        }, []);
    const [isModalOpen, setIsModalOpen] = (0, $cozmU.useState)(false); // With this sidebar's own popup open, the button is that popup's close toggle (a dismiss control),
    // so another active flow only blocks new starts while the popup is closed. Once this sidebar's own
    // flow is admitted, the popup has given way to the thinking bar, so the button is no longer its
    // close toggle even while the popup session is still open (a deferred custom prompt keeps it open
    // until the reply is ready).
    const { isAdmitted: isOwnFlowAdmitted } = (0, $eCmUm.useObjectSidebarRemixLifecycle)();
    const isNewStartBlocked = isRemixStartBlockedByActiveFlow && (!(isModalOpen || isObjectSidebarRemixModalOpen) || isOwnFlowAdmitted);
    const [lazyAdfDocument, setLazyAdfDocument] = (0, $cozmU.useState)(null);
    const [viewOpenAdfDocument, setViewOpenAdfDocument] = (0, $cozmU.useState)(null);
    const hasContentFromBody = (0, $cozmU.useMemo)(()=>{
        if (getAdfDocument) return false;
        if (!contentBodyValue) return false;
        const parsed = (0, $gRU1O.parseObjectSidebarRemixAdf)(contentBodyValue);
        return parsed !== null && !(0, $aHcFH.isEmptyAdf)(parsed);
    }, [
        contentBodyValue,
        getAdfDocument
    ]);
    const hasContent = getAdfDocument ? !isEditorEmpty : hasContentFromBody; // Measures treatment users who see an otherwise usable button disabled by another flow before
    // they click it. They cannot click, so the click exposure never counts them. A click in this
    // mount has already recorded the exposure, so a block after it (such as the user's own flow
    // being admitted) is not reported, and neither is a block both groups share (no content, the
    // parent disabling it, or the Smart Creation modal). Once per mount; records no exposure.
    const hasClickedRef = (0, $cozmU.useRef)(false);
    const hasReportedBlockedButtonRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (hasReportedBlockedButtonRef.current || hasClickedRef.current || isDisabled || !hasContent || showSmartCreationModal || !isNewStartBlocked) return;
        hasReportedBlockedButtonRef.current = true;
        reportLifecycleDiagnostic('observed', {
            operation: 'remixButtonBlocked',
            entryPath: shouldUseRovoRemixPath ? 'rovo-sidebar' : 'popup-open'
        });
    }, [
        hasContent,
        isDisabled,
        isNewStartBlocked,
        reportLifecycleDiagnostic,
        shouldUseRovoRemixPath,
        showSmartCreationModal
    ]);
    const resolvedAdfDocument = getAdfDocument ? lazyAdfDocument : viewOpenAdfDocument;
    const loadAdfDocument = (0, $cozmU.useCallback)(async ()=>{
        if (getAdfDocument) return getAdfDocument();
        if (!contentBodyValue) return null;
        return (0, $gRU1O.parseObjectSidebarRemixAdf)(contentBodyValue);
    }, [
        getAdfDocument,
        contentBodyValue
    ]);
    const loadLifecycleTreatmentAdfDocument = (0, $cozmU.useCallback)(async ()=>{
        const adfSourceVersion = adfSourceVersionRef.current;
        const { contentBodyValue: committedContentBodyValue, getAdfDocument: currentGetAdfDocument } = lifecycleAdfSourceRef.current;
        const adfDocument = currentGetAdfDocument ? await currentGetAdfDocument() : committedContentBodyValue ? (0, $gRU1O.parseObjectSidebarRemixAdf)(committedContentBodyValue) : null;
        return adfSourceVersionRef.current === adfSourceVersion ? adfDocument : null;
    }, []);
    const [isLoadingChunk, setIsLoadingChunk] = (0, $cozmU.useState)(false); // Tracks whether the popup has ever been activated so the lazy chunk is loaded
    const [hasBeenActivated, setHasBeenActivated] = (0, $cozmU.useState)(false); // Preload the heavy popup chunk on hover/focus so it's ready by the time the user clicks
    const handlePreload = (0, $cozmU.useCallback)(()=>{
        $3dbfc2b2d31d5d9f$var$remixObjectPagePopupLoader();
    }, []);
    const clearRemixUiState = (0, $cozmU.useCallback)(()=>{
        setIsModalOpen(false);
        setViewOpenAdfDocument(null);
        setLazyAdfDocument(null);
        clearRovoRemixStarted();
        hasStartedRovoRemixRef.current = false;
        isRemixStartActive.current = false;
    }, [
        clearRovoRemixStarted
    ]);
    const closeSessionModal = (0, $cozmU.useCallback)((options)=>{
        closeObjectSidebarRemixModal(options);
        clearRemixUiState();
    }, [
        clearRemixUiState,
        closeObjectSidebarRemixModal
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!contentId || !isModalOpen || isOwnFlowAdmitted || !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-close-object-sidebar-on-selection-remix', 'isEnabled', true)) return;
        return (0, $25qMx.subscribeToObjectSidebarRemixPickerClose)((requestedContentId)=>{
            if (requestedContentId === contentId) clearRemixUiState();
        });
    }, [
        clearRemixUiState,
        contentId,
        isModalOpen,
        isOwnFlowAdmitted
    ]);
    const fireRemixButtonAnalytics = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'remix',
                source: 'remixModalFromObjectSidebar',
                attributes: {
                    entryPoint: $3dbfc2b2d31d5d9f$export$3dba41599effe979
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handleClick = (0, $cozmU.useCallback)(async ()=>{
        if (!hasContent || showSmartCreationModal) return;
         // Both lifecycle groups reach this point, so read the cohort here, which records the
        // exposure, before the treatment-only block below. A blocked treatment button is disabled and
        // never gets here, so that case is measured by the `remixButtonBlocked` diagnostic instead.
        const isLifecycleExperimentActive = // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
        (0, $9wGTI.fg)('remix_state_rearchitecture_enabled') && (0, $6mKj3.isExperimentEnabled)('remix_state_rearchitecture_object_sidebar');
        hasClickedRef.current = true;
        if (isNewStartBlocked) return;
         // Record the Remix menu experiment exposure here, where the cohort decides which Remix
        // picker the person is about to see. Every cohort reaches this point, so all three are
        // counted at the same moment in the journey. Recording it further downstream, once each
        // cohort's own picker had appeared, left the variant2 group short, because their picker
        // only appears if the Rovo side panel is listening by the time this button asks it to
        // open.
        (0, $6mKj3.expVal)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'control');
        (0, $6mKj3.expVal)('cc-ce-maui-remix-menu-multivariant-aa', 'variant', 'control');
        const isAnyPageRemixModalOpen = isObjectSidebarRemixModalOpen || isModalOpen;
        if (shouldAttemptLifecycleAdmission) {
            if (!shouldUseRovoRemixPath && (isAnyPageRemixModalOpen || isLoadingChunk)) {
                if (isObjectSidebarRemixModalOpen) closeSessionModal();
                else clearRemixUiState();
                return;
            }
        }
        if (shouldUseRovoRemixPath) {
            if (!isRemixStartActive.current) {
                const startAttributes = {
                    entryPoint: $3dbfc2b2d31d5d9f$export$3dba41599effe979,
                    remixSource: $3dbfc2b2d31d5d9f$export$799fbc783b1be702,
                    product: 'confluence'
                };
                experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).REMIX_START,
                    id: (0, $irnO2.ExperienceName).REMIX_START,
                    attributes: startAttributes
                });
                (0, $kDDrf.startRemixCreateExperience)({
                    experienceTracker: experienceTracker,
                    attributes: startAttributes
                });
                isRemixStartActive.current = true;
            }
            const payload = {
                type: 'open-rovo-remix-sidebar',
                source: $3dbfc2b2d31d5d9f$export$799fbc783b1be702,
                consumeOnce: true,
                data: {
                    remixConsumer: 'renderer',
                    remixPreset: 'page'
                }
            };
            publishOpenRovoRemix(payload);
            publishRovoRemixLaunch(payload);
            markRovoRemixStarted();
            hasStartedRovoRemixRef.current = true;
            if (!isConversationAssistantSidebarActiveRef.current) openConversationAssistant('sidebar');
            fireRemixButtonAnalytics();
            return;
        }
        if (!shouldAttemptLifecycleAdmission && (isAnyPageRemixModalOpen || isLoadingChunk)) {
            clearRemixUiState();
            return;
        }
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            id: (0, $irnO2.ExperienceName).REMIX_START,
            attributes: {
                entryPoint: $3dbfc2b2d31d5d9f$export$3dba41599effe979,
                remixSource: $3dbfc2b2d31d5d9f$export$799fbc783b1be702,
                product: 'confluence'
            }
        });
        (0, $kDDrf.startRemixCreateExperience)({
            experienceTracker: experienceTracker,
            attributes: {
                entryPoint: $3dbfc2b2d31d5d9f$export$3dba41599effe979,
                remixSource: $3dbfc2b2d31d5d9f$export$799fbc783b1be702,
                product: 'confluence'
            }
        });
        isRemixStartActive.current = true;
        isLifecycleTreatmentActiveRef.current = isLifecycleExperimentActive;
        if (isLifecycleExperimentActive) {
            lifecycleAdfSourceRef.current = {
                contentBodyValue: contentBodyValue,
                getAdfDocument: getAdfDocument
            };
            adfSourceVersionRef.current += 1;
        }
        const startRequestId = isLifecycleExperimentActive ? startRequestIdRef.current + 1 : undefined;
        if (startRequestId !== undefined) startRequestIdRef.current = startRequestId;
        const adfSourceVersion_0 = isLifecycleExperimentActive ? adfSourceVersionRef.current : undefined;
        const isCurrentStart = ()=>startRequestId !== undefined && adfSourceVersion_0 !== undefined && startRequestIdRef.current === startRequestId && adfSourceVersionRef.current === adfSourceVersion_0; // Ensure the popup chunk is loaded before opening — the hover preload
        // means this will typically resolve instantly from cache
        setIsLoadingChunk(true);
        await $3dbfc2b2d31d5d9f$var$remixObjectPagePopupLoader();
        setIsLoadingChunk(false);
        if (!isLifecycleExperimentActive) {
            if (shouldAttemptLifecycleAdmission) {
                const doc = await loadAdfDocument();
                if (!doc || (0, $aHcFH.isEmptyAdf)(doc)) return;
                const lifecycleAdmission = admitObjectSidebarRemixLifecycle();
                if (lifecycleAdmission === 'rejected') return;
                hasOpenedRemixModalRef.current = true;
                if (getAdfDocument) setLazyAdfDocument(doc);
                else setViewOpenAdfDocument(doc);
                setIsModalOpen(true);
                setHasBeenActivated(true);
            } else if (getAdfDocument) {
                const doc_0 = await getAdfDocument();
                if (doc_0) {
                    setLazyAdfDocument(doc_0);
                    hasOpenedRemixModalRef.current = true;
                    setIsModalOpen(true);
                    setHasBeenActivated(true);
                }
            } else if (contentBodyValue) {
                const doc_1 = (0, $gRU1O.parseObjectSidebarRemixAdf)(contentBodyValue);
                if (doc_1) {
                    setViewOpenAdfDocument(doc_1);
                    hasOpenedRemixModalRef.current = true;
                    setIsModalOpen(true);
                    setHasBeenActivated(true);
                }
            }
            fireRemixButtonAnalytics();
            return;
        }
        if (!isCurrentStart()) return;
        const startResult = await (0, $1Tfg5.prepareObjectSidebarPageRemixStart)({
            resolveAdfDocument: loadLifecycleTreatmentAdfDocument,
            isCurrent: isCurrentStart,
            onRejected: (reason)=>{
                reportLifecycleDiagnostic('rejected', {
                    operation: 'preparePageRemixStart',
                    entryPath: 'popup-open',
                    rejectionReason: reason
                });
            }
        });
        if (startResult.status === 'rejected') return;
        hasOpenedRemixModalRef.current = true;
        openObjectSidebarRemixModal(startResult.adfDocument, loadLifecycleTreatmentAdfDocument, {
            isLifecycleTreatment: isLifecycleExperimentActive
        });
        fireRemixButtonAnalytics();
    }, [
        experienceTracker,
        hasContent,
        isModalOpen,
        isObjectSidebarRemixModalOpen,
        isNewStartBlocked,
        showSmartCreationModal,
        clearRemixUiState,
        closeSessionModal,
        isLoadingChunk,
        getAdfDocument,
        contentBodyValue,
        loadAdfDocument,
        loadLifecycleTreatmentAdfDocument,
        publishOpenRovoRemix,
        publishRovoRemixLaunch,
        openConversationAssistant,
        fireRemixButtonAnalytics,
        markRovoRemixStarted,
        shouldUseRovoRemixPath,
        shouldAttemptLifecycleAdmission,
        admitObjectSidebarRemixLifecycle,
        openObjectSidebarRemixModal,
        reportLifecycleDiagnostic
    ]);
    const experienceTrackerRef = (0, $cozmU.useRef)(experienceTracker);
    experienceTrackerRef.current = experienceTracker;
    const abortActiveRemixStart = (0, $cozmU.useCallback)((reason_0, options_0 = {})=>{
        if (!isRemixStartActive.current) return;
        if (options_0.releaseLifecycle !== false) releaseRetainedLifecycleForToken(retainedLifecycleToken, 'abandoned');
        experienceTrackerRef.current.abort({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            reason: reason_0,
            attributes: {
                reason: reason_0
            }
        });
        (0, $kDDrf.abortRemixCreateExperienceIfNotCommitted)(experienceTrackerRef.current, hasOpenedRemixModalRef.current);
        isRemixStartActive.current = false;
    }, [
        releaseRetainedLifecycleForToken,
        retainedLifecycleToken
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>abortActiveRemixStart('User closed remix overlay', {
                releaseLifecycle: false
            });
    }, [
        abortActiveRemixStart
    ]);
    const onLocalModalStopThinking = (0, $cozmU.useCallback)((options_1)=>{
        clearRovoRemixStarted();
        if (options_1?.reopenModal) {
            hasOpenedRemixModalRef.current = true;
            setIsModalOpen(true);
        }
    }, [
        clearRovoRemixStarted
    ]); // Closing the Rovo panel sends no message that this button can listen for, so the only way to
    // notice it is to watch whether the panel is showing. The same click that starts the Remix also
    // asks the panel to open, so there is a short moment where the panel is not showing yet. A close
    // is therefore only acted on once the panel has been seen showing at least once.
    const isRovoPanelOpen = isConversationAssistantSidebarActive || mode !== undefined;
    const hasSeenRovoPanelOpenRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (isRovoPanelOpen) {
            hasSeenRovoPanelOpenRef.current = true;
            return;
        }
        if (!hasSeenRovoPanelOpenRef.current) return;
        hasSeenRovoPanelOpenRef.current = false; // Only the experience abort belongs here. Clearing the started flag is the session
        // provider's job, because it has to happen even when this button is unmounted.
        if (hasStartedRovoRemixRef.current) {
            hasStartedRovoRemixRef.current = false;
            abortActiveRemixStart('User closed remix overlay');
        }
    }, [
        abortActiveRemixStart,
        isRovoPanelOpen
    ]); // Another Remix entry point taking over. This button asks for a Remix of the whole page, while
    // the text selection toolbar and the block hover icon ask for a Remix of the selection, so an
    // announcement for anything other than the page means one of those has taken over.
    (0, $hdBxM.useSubscribe)({
        topic: (0, $k1Pvg.Topics).AI_MATE
    }, (payload_0)=>{
        if (payload_0.type !== 'open-rovo-remix-sidebar' || payload_0.data.remixPreset === 'page') return;
        hasStartedRovoRemixRef.current = false;
        abortActiveRemixStart('Another Remix entry point took over');
        clearRovoRemixStarted();
    });
    const remixPageLabelMessage = $3dbfc2b2d31d5d9f$var$i18n.remixPageLabel;
    const hasContentTooltipMessage = $3dbfc2b2d31d5d9f$var$i18n.remixPageTooltip;
    const inProgressTooltipMessage = $3dbfc2b2d31d5d9f$var$i18n.remixInProgressTooltip;
    const emptyTooltipMessage = $3dbfc2b2d31d5d9f$var$i18n.remixPageEmptyTooltip;
    const shouldUseLifecycleCloseHandler = retainedLifecycleToken !== undefined;
    const isRemixInProgress = showSmartCreationModal || isNewStartBlocked;
    let tooltipContent;
    if (isRemixInProgress) tooltipContent = formatMessage(inProgressTooltipMessage);
    else if (isObjectSidebarRemixModalOpen || isModalOpen) tooltipContent = undefined;
    else if (hasContent) tooltipContent = formatMessage(hasContentTooltipMessage);
    else tooltipContent = formatMessage(emptyTooltipMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: registerPopupAnchor,
        "data-testid": "sidebar-remix-button-container",
        onMouseEnter: handlePreload,
        onFocus: handlePreload,
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: "left",
        content: tooltipContent,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        onClick: handleClick,
        appearance: "subtle",
        shape: isRovoButtonEnabled ? 'default' : 'circle',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))),
        label: formatMessage(remixPageLabelMessage),
        testId: "sidebar-remix-button",
        isLoading: isLoadingChunk,
        isDisabled: isDisabled || !hasContent || isRemixInProgress,
        // form that does not record an exposure, because rendering must not enter anyone into
        // the experiment), or the popup the lifecycle treatment hosts in the session provider,
        // which has no overlay trigger of its own to show the selected state.
        isSelected: isRovoRemixStarted && shouldUseRovoRemixPath || isObjectSidebarRemixModalOpen && !showSmartCreationModal && !isNewStartBlocked
    })), !shouldUseRovoRemixPath && hasBeenActivated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3dbfc2b2d31d5d9f$var$RemixObjectPagePopup, {
        adfDocument: resolvedAdfDocument ?? {
            type: 'doc',
            version: 1,
            content: []
        },
        isModalOpen: isModalOpen,
        isRemixStartBlocked: isRemixStartBlockedByActiveFlow,
        onClose: clearRemixUiState,
        onStopThinking: onLocalModalStopThinking,
        popupRepositionKey: rightSidebarWidth,
        onOpenSidebarConversation: handleOpenSidebarConversation,
        shouldWaitForRemixHandoffBeforeClose: shouldUseLifecycleCloseHandler,
        prefetchedSpaceHiddenOptions: didPrefetchSpaceOptions ? prefetchedSpaceHiddenOptions : undefined,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: (0, $hekY6.default)([
                    "_1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _39xV02N91d _0jFU0VN91d _1pp6NdYbGa"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                appearance: "subtle",
                shape: isRovoButtonEnabled ? 'default' : 'circle',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))),
                label: formatMessage(remixPageLabelMessage),
                testId: "sidebar-remix-button",
                isDisabled: isDisabled || !hasContent || isRemixInProgress,
                isSelected: isModalOpen && !showSmartCreationModal,
                "aria-hidden": "true",
                className: (0, $hekY6.default)([
                    "_0fKRyPnQyn"
                ])
            }))
    }));
};
module.exports["OBJECT_LEVEL_REMIX_ENTRY_POINT"] = $3dbfc2b2d31d5d9f$export$3dba41599effe979;
module.exports["OBJECT_LEVEL_REMIX_SOURCE"] = $3dbfc2b2d31d5d9f$export$799fbc783b1be702;
module.exports["RemixPanelButton"] = $3dbfc2b2d31d5d9f$export$def261f8e2f8a585;

});

parcelRegister("1pCE4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6f1e13d4a3a429b849d45ea939386ed0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $10761a64419352ea$var$_react = $10761a64419352ea$var$_interopRequireDefault((parcelRequire("cozmU")));

var $10761a64419352ea$var$_iconNew = $10761a64419352ea$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $10761a64419352ea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeRemix".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-generative-remix
 * Usage guidance:
 * Reserved for Remix with Rovo
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $10761a64419352ea$var$AiGenerativeRemixIcon = (props)=>/*#__PURE__*/ $10761a64419352ea$var$_react.default.createElement($10761a64419352ea$var$_iconNew.default, Object.assign({
        name: "AiGenerativeRemixIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M15.78 11.22a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22h-2.845a2 2 0 0 1-1.552-.74l-1.124-1.382.967-1.189 1.321 1.626a.5.5 0 0 0 .388.185h2.845l-1.22-1.22 1.06-1.06z"/><path fill="currentcolor" d="M15.78 3.72a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06L13.44 5H10.6a.5.5 0 0 0-.39.19l-5.75 7.08a2 2 0 0 1-1.55.73H0v-1.5h2.91a.5.5 0 0 0 .39-.18l5.75-7.08a2 2 0 0 1 1.55-.74h2.85l-1.22-1.22 1.06-1.06zM6 4.25a.75.75 0 0 1-.49.71l-1.1.4a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.41 0l-.4-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.48-.59L0 4.25l.01-.12a.75.75 0 0 1 .48-.59l1.1-.4a.5.5 0 0 0 .3-.3l.4-1.1.05-.11A.75.75 0 0 1 3 1.24l.12.01a.75.75 0 0 1 .54.38l.05.11.4 1.1c.05.14.16.25.3.3l1.1.4a.75.75 0 0 1 .49.71"/>`
    }, props));
$10761a64419352ea$var$AiGenerativeRemixIcon.displayName = 'AiGenerativeRemixIcon';
var $10761a64419352ea$var$_default = module.exports.default = $10761a64419352ea$var$AiGenerativeRemixIcon;

});

parcelRegister("kDDrf", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- fallback for insecure contexts where crypto.randomUUID is unavailable

var $03RpJ = parcelRequire("03RpJ");


var $3PJhM = parcelRequire("3PJhM");


var $irnO2 = parcelRequire("irnO2");


var $cvQra = parcelRequire("cvQra");


var $iBsvI = parcelRequire("iBsvI");


var $60x4y = parcelRequire("60x4y");

const $99e5a5c6ac11dcd8$var$randomId = ()=>{
    if (globalThis?.crypto?.randomUUID) return globalThis.crypto.randomUUID();
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- fallback for insecure contexts where crypto.randomUUID is unavailable
    return (0, $03RpJ.default)();
};
const $99e5a5c6ac11dcd8$var$SEND_MESSAGE_EXPERIENCE_NAMES = new Set([
    (0, $irnO2.ExperienceName).SEND_MESSAGE
]);
const $99e5a5c6ac11dcd8$var$CREATE_TERMINAL_EXPERIENCE_NAMES = new Set([
    (0, $irnO2.ExperienceName).REMIX_RENDERS_IN_MODAL,
    (0, $irnO2.ExperienceName).REMIX_INSERT
]);
const $99e5a5c6ac11dcd8$var$IMAGE_GENERATION_SAFETY_ERROR_CODES = new Set([
    'ACCEPTABLE_USE_VIOLATIONS',
    'IMAGE_SAFETY_REJECTED',
    'SAFETY_VIOLATION'
]);
const $99e5a5c6ac11dcd8$var$toError = (error)=>error ?? new Error('aiMateSendMessage failed');
const $99e5a5c6ac11dcd8$var$getErrorCode = (error)=>{
    if (!(0, $3PJhM.isRecord)(error)) return undefined;
    const errorAttributes = (0, $3PJhM.isRecord)(error.errorAttributes) ? error.errorAttributes : undefined;
    if (typeof errorAttributes?.errorCode === 'string') return errorAttributes.errorCode;
    const detail = (0, $3PJhM.isRecord)(error.detail) ? error.detail : undefined;
    const message = (0, $3PJhM.isRecord)(detail?.message) ? detail.message : undefined;
    return typeof message?.message_template === 'string' ? message.message_template : undefined;
};
const $99e5a5c6ac11dcd8$var$getExpectedGenerationSuccessOutcome = (event)=>{
    const attributes = event.attributes;
    if (attributes?.isSafetyViolation === true) return 0, $60x4y.REMIX_IMAGE_GENERATION_SAFETY_REFUSAL_OUTCOME;
    const error = 'error' in event ? event.error : undefined;
    const errorCode = $99e5a5c6ac11dcd8$var$getErrorCode(error) ?? attributes?.errorType;
    if (typeof errorCode === 'string' && $99e5a5c6ac11dcd8$var$IMAGE_GENERATION_SAFETY_ERROR_CODES.has(errorCode)) return 0, $60x4y.REMIX_IMAGE_GENERATION_SAFETY_REFUSAL_OUTCOME;
    return undefined;
};
const $99e5a5c6ac11dcd8$var$withFeatureArea = (attributes, context)=>{
    const featureArea = context.featureArea ?? attributes?.featureArea;
    return {
        ...attributes,
        ...featureArea !== undefined && {
            featureArea: featureArea
        }
    };
};
let $99e5a5c6ac11dcd8$var$activeCreateCollectContext;
const $99e5a5c6ac11dcd8$var$settleCreateContext = (context)=>{
    context.isCreateSettled = true;
    (0, $cvQra.remixCreateTerminalOwnership).release(context.remixCreateId);
};
const $99e5a5c6ac11dcd8$var$matchesTerminal = (event, context)=>{
    if (!$99e5a5c6ac11dcd8$var$CREATE_TERMINAL_EXPERIENCE_NAMES.has(event.name)) return false;
    const attributes = event.attributes;
    const eventRemixCreateId = attributes?.remixCreateId;
    if (context.remixCreateId && typeof eventRemixCreateId === 'string') return eventRemixCreateId === context.remixCreateId;
    const eventConversationId = attributes?.conversationId;
    if (context.conversationChannelId && typeof eventConversationId === 'string') return eventConversationId === context.conversationChannelId;
    return Boolean(context.allowCollectFallback);
};
const $99e5a5c6ac11dcd8$var$matchesSendMessageFailure = (event, context)=>{
    if (!$99e5a5c6ac11dcd8$var$SEND_MESSAGE_EXPERIENCE_NAMES.has(event.name) || event.action !== 'taskFail') return false;
    const attributes = event.attributes;
    if (attributes?.isRemixCreate !== true) return false;
    const requestConversationId = attributes?.conversationId;
    if (context.conversationChannelId && requestConversationId === context.conversationChannelId) return true;
    // If the event's conversationId is unavailable, fall back to the single-inflight
    // assumption (there is only one remix create stream at a time).
    return Boolean(context.allowCollectFallback);
};
const $99e5a5c6ac11dcd8$export$fce521e73e6e1f1e = (context)=>{
    let hasStopped = false;
    return (events, experience)=>{
        if (hasStopped || context.isCreateSettled) {
            hasStopped = true;
            return;
        }
        for (const event of events){
            // 1) Upstream generation-stream failure → succeed for a handled safety refusal,
            // otherwise fail the parent.
            if ($99e5a5c6ac11dcd8$var$matchesSendMessageFailure(event, context)) {
                hasStopped = true;
                $99e5a5c6ac11dcd8$var$settleCreateContext(context);
                const attributes = event.attributes;
                const successOutcome = $99e5a5c6ac11dcd8$var$getExpectedGenerationSuccessOutcome(event);
                if (successOutcome) {
                    experience.succeed({
                        attributes: {
                            ...$99e5a5c6ac11dcd8$var$withFeatureArea(attributes, context),
                            outcome: successOutcome,
                            succeededVia: event.name
                        }
                    });
                    return;
                }
                experience.fail({
                    error: $99e5a5c6ac11dcd8$var$toError(event.error),
                    attributes: {
                        ...$99e5a5c6ac11dcd8$var$withFeatureArea(attributes, context),
                        failureSource: 'send_message_collect',
                        failureStage: 'request',
                        upstreamExperience: event.name
                    }
                });
                return;
            }
            if (!$99e5a5c6ac11dcd8$var$matchesTerminal(event, context)) continue;
            const attributes = event.attributes;
            // 2) A terminal experience FAILED → succeed for a handled safety refusal,
            // otherwise fail the parent.
            if (event.action === 'taskFail') {
                hasStopped = true;
                $99e5a5c6ac11dcd8$var$settleCreateContext(context);
                const successOutcome = $99e5a5c6ac11dcd8$var$getExpectedGenerationSuccessOutcome(event);
                if (successOutcome) {
                    experience.succeed({
                        attributes: {
                            ...$99e5a5c6ac11dcd8$var$withFeatureArea(attributes, context),
                            outcome: successOutcome,
                            succeededVia: event.name
                        }
                    });
                    return;
                }
                experience.fail({
                    error: $99e5a5c6ac11dcd8$var$toError(event.error),
                    attributes: {
                        ...$99e5a5c6ac11dcd8$var$withFeatureArea(attributes, context),
                        failureSource: 'terminal_collect',
                        failureStage: 'render',
                        upstreamExperience: event.name
                    }
                });
                return;
            }
            // 3) A terminal experience ABORTED → abort the parent.
            if (event.action === 'taskAbort') {
                hasStopped = true;
                $99e5a5c6ac11dcd8$var$settleCreateContext(context);
                experience.abort({
                    reason: `terminal_${event.name}_aborted`,
                    attributes: {
                        ...$99e5a5c6ac11dcd8$var$withFeatureArea(attributes, context),
                        upstreamExperience: event.name
                    }
                });
                return;
            }
            // 4) A safety-marked terminal is a handled response, so succeed the reliability
            // parent with an explicit outcome.
            if (event.action === 'taskSuccess') {
                hasStopped = true;
                $99e5a5c6ac11dcd8$var$settleCreateContext(context);
                const successOutcome = $99e5a5c6ac11dcd8$var$getExpectedGenerationSuccessOutcome(event);
                if (successOutcome) {
                    experience.succeed({
                        attributes: {
                            ...$99e5a5c6ac11dcd8$var$withFeatureArea(attributes, context),
                            outcome: successOutcome,
                            succeededVia: event.name
                        }
                    });
                    return;
                }
                // An ordinary terminal success succeeds the parent immediately.
                experience.succeed({
                    attributes: {
                        ...$99e5a5c6ac11dcd8$var$withFeatureArea(attributes, context),
                        succeededVia: event.name
                    }
                });
                return;
            }
        }
    };
};
const $99e5a5c6ac11dcd8$export$f53526ec87ae9eaf = ({ experienceTracker: experienceTracker, attributes: attributes, includeOpenMenuExperience: includeOpenMenuExperience = true })=>{
    const remixCreateId = $99e5a5c6ac11dcd8$var$randomId();
    const featureArea = (0, $iBsvI.getRemixFeatureArea)({
        remixType: attributes?.remixType,
        existingFeatureArea: attributes?.featureArea
    });
    const startAttributes = {
        ...attributes,
        ...featureArea !== undefined && {
            featureArea: featureArea
        },
        remixCreateId: remixCreateId
    };
    const collectContext = {
        remixCreateId: remixCreateId,
        ...includeOpenMenuExperience && {
            openMenuAttributes: startAttributes
        },
        featureArea: featureArea,
        allowCollectFallback: true
    };
    $99e5a5c6ac11dcd8$var$activeCreateCollectContext = collectContext;
    experienceTracker.start({
        name: (0, $irnO2.ExperienceName).REMIX_CREATE,
        id: remixCreateId,
        attributes: startAttributes,
        collect: $99e5a5c6ac11dcd8$export$fce521e73e6e1f1e(collectContext)
    });
    if (includeOpenMenuExperience) experienceTracker.start({
        name: (0, $irnO2.ExperienceName).REMIX_OPEN_MENU,
        id: (0, $irnO2.ExperienceName).REMIX_OPEN_MENU,
        attributes: startAttributes
    });
};
const $99e5a5c6ac11dcd8$export$8194201fd9adfb49 = ()=>$99e5a5c6ac11dcd8$var$activeCreateCollectContext?.isCreateSettled ? undefined : $99e5a5c6ac11dcd8$var$activeCreateCollectContext?.remixCreateId;
const $99e5a5c6ac11dcd8$export$701b0d2def6c3f0f = (experienceTracker)=>{
    const context = $99e5a5c6ac11dcd8$var$activeCreateCollectContext;
    if (!context?.openMenuAttributes || context.isOpenMenuSettled) return;
    context.isOpenMenuSettled = true;
    experienceTracker.succeed({
        name: (0, $irnO2.ExperienceName).REMIX_OPEN_MENU,
        attributes: context.openMenuAttributes
    });
};
const $99e5a5c6ac11dcd8$export$78cf909554bc5274 = (experienceTracker, attributes)=>{
    const context = $99e5a5c6ac11dcd8$var$activeCreateCollectContext;
    if (!context || context.isCreateSettled) return;
    $99e5a5c6ac11dcd8$var$settleCreateContext(context);
    experienceTracker.succeed({
        name: (0, $irnO2.ExperienceName).REMIX_CREATE,
        attributes: {
            ...context.openMenuAttributes,
            ...attributes,
            succeededVia: (0, $irnO2.ExperienceName).REMIX_AIFC_HANDOFF
        }
    });
};
const $99e5a5c6ac11dcd8$export$f7f9deae8856cb4 = (experienceTracker)=>{
    const context = $99e5a5c6ac11dcd8$var$activeCreateCollectContext;
    if (!context || context.isCreateSettled) return;
    $99e5a5c6ac11dcd8$var$settleCreateContext(context);
    experienceTracker.succeed({
        name: (0, $irnO2.ExperienceName).REMIX_CREATE,
        attributes: {
            ...context.openMenuAttributes,
            ...context.pendingSelectionAttributes,
            outcome: (0, $60x4y.REMIX_IMAGE_GENERATION_SAFETY_REFUSAL_OUTCOME)
        }
    });
};
const $99e5a5c6ac11dcd8$export$3d7752ee631c9bec = (experienceTracker, error, attributes)=>{
    const context = $99e5a5c6ac11dcd8$var$activeCreateCollectContext;
    if (!context || context.isCreateSettled) return;
    $99e5a5c6ac11dcd8$var$settleCreateContext(context);
    experienceTracker.fail({
        name: (0, $irnO2.ExperienceName).REMIX_CREATE,
        error: error,
        attributes: {
            ...context.openMenuAttributes,
            ...$99e5a5c6ac11dcd8$var$withFeatureArea(attributes, context)
        }
    });
};
const $99e5a5c6ac11dcd8$export$ebb7b0773a85e89e = (experienceTracker, reason)=>{
    const context = $99e5a5c6ac11dcd8$var$activeCreateCollectContext;
    if (!context) return;
    const attributes = {
        ...context.openMenuAttributes,
        ...context.pendingSelectionAttributes,
        reason: reason
    };
    if (context.openMenuAttributes && !context.isOpenMenuSettled) {
        context.isOpenMenuSettled = true;
        experienceTracker.abort({
            name: (0, $irnO2.ExperienceName).REMIX_OPEN_MENU,
            reason: reason,
            attributes: attributes
        });
    }
    if (!context.isCreateSettled && !(0, $cvQra.remixCreateTerminalOwnership).isOwnedByTerminal(context.remixCreateId)) {
        $99e5a5c6ac11dcd8$var$settleCreateContext(context);
        experienceTracker.abort({
            name: (0, $irnO2.ExperienceName).REMIX_CREATE,
            reason: reason,
            attributes: attributes
        });
    }
};
const $99e5a5c6ac11dcd8$export$c3cccc5477469a41 = (experienceTracker, hasCommitted, reason = 'User closed remix overlay')=>{
    if (!hasCommitted) $99e5a5c6ac11dcd8$export$ebb7b0773a85e89e(experienceTracker, reason);
};
/**
 * Records a non-gating milestone sub-experience (select-option / show-loading) as
 * the flow advances: an instantaneous start-then-succeed. These are funnel
 * breadcrumbs; the parent's success is owned by the terminal experiences via
 * `collect`, not by these milestones.
 */ const $99e5a5c6ac11dcd8$var$recordRemixCreateMilestone = (experienceTracker, name, attributes)=>{
    const remixCreateId = $99e5a5c6ac11dcd8$export$8194201fd9adfb49();
    const milestoneAttributes = {
        ...attributes,
        remixCreateId: remixCreateId
    };
    experienceTracker.start({
        name: name,
        id: name,
        attributes: milestoneAttributes
    });
    experienceTracker.succeed({
        name: name,
        attributes: milestoneAttributes
    });
};
const $99e5a5c6ac11dcd8$export$8ce0294ce28ac3ae = ({ remixType: remixType, remixSubtype: remixSubtype })=>{
    if (!$99e5a5c6ac11dcd8$var$activeCreateCollectContext || $99e5a5c6ac11dcd8$var$activeCreateCollectContext.isCreateSettled) return;
    $99e5a5c6ac11dcd8$var$activeCreateCollectContext.pendingSelectionAttributes = remixType === undefined && remixSubtype === undefined ? undefined : {
        remixType: remixType,
        remixSubtype: remixSubtype
    };
};
const $99e5a5c6ac11dcd8$export$88ef25856d821447 = ({ experienceTracker: experienceTracker, conversationId: conversationId, remixType: remixType, remixSubtype: remixSubtype, includesFreegenPrompt: includesFreegenPrompt })=>{
    if (conversationId) $99e5a5c6ac11dcd8$export$799e564bf3ca201c(experienceTracker, conversationId);
    const featureArea = (0, $iBsvI.getRemixFeatureArea)({
        remixType: remixType,
        existingFeatureArea: $99e5a5c6ac11dcd8$var$activeCreateCollectContext?.featureArea
    });
    if ($99e5a5c6ac11dcd8$var$activeCreateCollectContext) $99e5a5c6ac11dcd8$var$activeCreateCollectContext.featureArea = featureArea;
    const attributes = {
        remixType: remixType,
        remixSubtype: remixSubtype,
        includesFreegenPrompt: includesFreegenPrompt,
        ...featureArea !== undefined && {
            featureArea: featureArea
        }
    };
    if ($99e5a5c6ac11dcd8$var$activeCreateCollectContext) $99e5a5c6ac11dcd8$var$activeCreateCollectContext.pendingSelectionAttributes = attributes;
    experienceTracker.updateAttributes({
        name: (0, $irnO2.ExperienceName).REMIX_CREATE,
        attributes: attributes
    });
    $99e5a5c6ac11dcd8$var$recordRemixCreateMilestone(experienceTracker, (0, $irnO2.ExperienceName).REMIX_SELECT_OPTION, attributes);
    $99e5a5c6ac11dcd8$var$recordRemixCreateMilestone(experienceTracker, (0, $irnO2.ExperienceName).REMIX_SHOW_LOADING, attributes);
};
const $99e5a5c6ac11dcd8$export$799e564bf3ca201c = (experienceTracker, conversationId)=>{
    experienceTracker.updateAttributes({
        name: (0, $irnO2.ExperienceName).REMIX_CREATE,
        attributes: {
            conversationId: conversationId
        }
    });
    if ($99e5a5c6ac11dcd8$var$activeCreateCollectContext) $99e5a5c6ac11dcd8$var$activeCreateCollectContext.conversationChannelId = conversationId;
};
module.exports["startRemixCreateExperience"] = $99e5a5c6ac11dcd8$export$f53526ec87ae9eaf;
module.exports["getActiveRemixCreateId"] = $99e5a5c6ac11dcd8$export$8194201fd9adfb49;
module.exports["succeedRemixOpenMenuExperience"] = $99e5a5c6ac11dcd8$export$701b0d2def6c3f0f;
module.exports["succeedRemixCreateExperienceAtHandoff"] = $99e5a5c6ac11dcd8$export$78cf909554bc5274;
module.exports["succeedRemixCreateExperienceForSafetyRefusal"] = $99e5a5c6ac11dcd8$export$f7f9deae8856cb4;
module.exports["failRemixCreateExperience"] = $99e5a5c6ac11dcd8$export$3d7752ee631c9bec;
module.exports["abortRemixCreateExperience"] = $99e5a5c6ac11dcd8$export$ebb7b0773a85e89e;
module.exports["abortRemixCreateExperienceIfNotCommitted"] = $99e5a5c6ac11dcd8$export$c3cccc5477469a41;
module.exports["updateRemixCreatePendingSelection"] = $99e5a5c6ac11dcd8$export$8ce0294ce28ac3ae;
module.exports["trackRemixCreateOptionSelected"] = $99e5a5c6ac11dcd8$export$88ef25856d821447;

});

parcelRegister("cvQra", function(module, exports) {
const $ea4cf4ccfd984408$var$committedRemixCreateIds = new Set();
const $ea4cf4ccfd984408$export$76401a56620523ea = {
    commit (remixCreateId) {
        $ea4cf4ccfd984408$var$committedRemixCreateIds.add(remixCreateId);
    },
    isOwnedByTerminal (remixCreateId) {
        return remixCreateId !== undefined && $ea4cf4ccfd984408$var$committedRemixCreateIds.has(remixCreateId);
    },
    release (remixCreateId) {
        if (remixCreateId !== undefined) $ea4cf4ccfd984408$var$committedRemixCreateIds.delete(remixCreateId);
    },
    reset () {
        $ea4cf4ccfd984408$var$committedRemixCreateIds.clear();
    }
};
module.exports["remixCreateTerminalOwnership"] = $ea4cf4ccfd984408$export$76401a56620523ea;

});

parcelRegister("iBsvI", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");

function $a0b10823d5792e1c$export$63b2cbfa1855c730({ remixType: remixType, existingFeatureArea: existingFeatureArea }) {
    if (!(0, $4o0zT.isExperimentEnabled)('maui_remix_feature_area_by_type_exp_gate')) return existingFeatureArea;
    return remixType ? `remix-${remixType}` : existingFeatureArea ?? 'remix';
}
module.exports["getRemixFeatureArea"] = $a0b10823d5792e1c$export$63b2cbfa1855c730;

});

parcelRegister("60x4y", function(module, exports) {
const $cb4dc77a42849518$export$c55fdf65d0c3a601 = 'image_generation_safety_violation';
module.exports["REMIX_IMAGE_GENERATION_SAFETY_REFUSAL_OUTCOME"] = $cb4dc77a42849518$export$c55fdf65d0c3a601;

});

parcelRegister("9T8LG", function(module, exports) {

let $73300d44fe8f4cd4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $73300d44fe8f4cd4$var$load("6wr18"),
    $73300d44fe8f4cd4$var$load("gQb60"),
    $73300d44fe8f4cd4$var$load("iLt7f"),
    $73300d44fe8f4cd4$var$load("Oocfq"),
    $73300d44fe8f4cd4$var$load("dEA3e"),
    $73300d44fe8f4cd4$var$load("ffEVr"),
    $73300d44fe8f4cd4$var$load("8J2eZ")
]).then(()=>parcelRequire('gbIFX'));

});


//# sourceMappingURL=RemixPanelButton.59851bcf.js.map
